<!-- src/App.vue -->
<!-- eslint-disable no-console -->
<script setup lang="ts">
import {
    computed,
    onBeforeMount,
    onBeforeUnmount,
    onMounted,
    ref,
} from "vue";
import { NConfigProvider, NGlobalStyle, darkTheme } from "naive-ui";
import { useAppStore } from "./store/modules/app";
import { useThemeStore } from "./store/modules/theme";
import { naiveDateLocales, naiveLocales } from "./locales/naive";
import { handlePingPong, updateExchangeRate } from "./service/request/shared";
import LoginOverlay from "./components/auth/LoginOverlay.vue";
import GuestModeBanner from "./components/auth/GuestModeBanner.vue";

defineOptions({
    name: "App",
});

onBeforeMount(async () => {
    try {
        await handlePingPong();
    } catch (error: any) {
        console.log("onBeforeMount error: ", error);
    }
});
const exchangeRateIntervalId = ref<number | null>(null);
const appStore = useAppStore();
const themeStore = useThemeStore();
const naiveDarkTheme = computed(() =>
    themeStore.darkMode ? darkTheme : undefined
);
const naiveLocale = computed(() => {
    return naiveLocales[appStore.locale];
});
const naiveDateLocale = computed(() => {
    return naiveDateLocales[appStore.locale];
});

onMounted(() => {
    exchangeRateIntervalId.value = window.setInterval(
        updateExchangeRate,
        60000
    );
    updateExchangeRate().then().catch();
});
onBeforeUnmount(() => {
    if (exchangeRateIntervalId.value) {
        clearInterval(exchangeRateIntervalId.value);
        exchangeRateIntervalId.value = null;
    }
});
</script>

<template>
    <NConfigProvider :theme="naiveDarkTheme" :theme-overrides="themeStore.naiveTheme" :locale="naiveLocale"
        :date-locale="naiveDateLocale" class="h-full" :class="[appStore.direction]">
        <AppProvider>
            <!-- Guest Mode Banner -->
            <GuestModeBanner />

            <!-- Main App Content -->
            <RouterView class="bg-layout" />

            <!-- Global Login Overlay -->
            <LoginOverlay />
        </AppProvider>
        <NGlobalStyle />
    </NConfigProvider>
</template>

<style scoped></style>
